import {create} from 'zustand';
import {persist} from 'zustand/middleware';

import {createSelectors} from '@/config/zustand/selectorGenerator';
import type {GetProfileQuery} from '@/gql-codegen/generated';

type IUserProfileState = {
  user?: GetProfileQuery['profile'];
};

type IUserProfileActions = {
  setUser: (user?: GetProfileQuery['profile']) => void;
  clearUser: () => void;
};

const useProfileStoreBase = create<IUserProfileState & IUserProfileActions>()(
  persist(
    set => ({
      user: undefined,
      setUser: user => set({user}),
      clearUser: () => set({user: undefined}),
    }),
    {
      name: 'user-profile',
    },
  ),
);

export const useProfileStore = createSelectors(useProfileStoreBase);
